import React from 'react';
import { Battery, Zap, ShieldCheck, Clock } from 'lucide-react';

interface FeatureProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const Feature: React.FC<FeatureProps> = ({ icon, title, description }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1">
      <div className="flex items-center mb-4">
        <div className="bg-primary/10 p-3 rounded-full mr-4 text-primary">
          {icon}
        </div>
        <h3 className="text-xl font-bold text-gray-800">{title}</h3>
      </div>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

const FeaturesSection: React.FC = () => {
  return (
    <section id="features" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Why Choose ECORIDE?</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Our electric bicycles combine cutting-edge technology with elegant design, 
            solving your urban mobility challenges while enhancing your riding experience.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <Feature 
            icon={<Battery size={24} />}
            title="Exceptional Range"
            description="One charge delivers up to 120km of riding, eliminating range anxiety and keeping you moving all day long."
          />
          <Feature 
            icon={<Zap size={24} />}
            title="Powerful Motor"
            description="Our 500W motor provides ample power to tackle hills and rough terrain with ease, while maintaining energy efficiency."
          />
          <Feature 
            icon={<ShieldCheck size={24} />}
            title="Smart Security"
            description="Integrated GPS tracking, alarm system, and smartphone connectivity keep your bike secure wherever you go."
          />
          <Feature 
            icon={<Clock size={24} />}
            title="Fast Charging"
            description="Innovative battery technology allows for a full charge in just 3 hours, so you're always ready to ride."
          />
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;